// Regras de pneus que o painel espelha do servidor (o servidor e quem de fato confere permissao e valida tudo).
export interface EixoCfg { esq: number; dir: number; rotulo?: string }
export interface ConfigModelo { eixos: EixoCfg[]; estepes: number }
export interface Posicao { cod: string; eixo: number; col: number; lado: string; rotulo: string; estepe?: boolean }

// mesmos codigos do servidor (services/pneus.ts): 1E 1D, 2EE 2EI 2DI 2DE (E=esquerdo/direito, depois E=externo/I=interno), ES (um estepe) ou ES1, ES2...
export function gerarPosicoes(cfg: ConfigModelo): Posicao[] {
  const out: Posicao[] = []
  cfg.eixos.forEach((e, k) => {
    const n = k + 1, rot = e.rotulo || `Eixo ${n}`
    if (e.esq === 2) { out.push({ cod: `${n}EE`, eixo: n, col: -2, lado: "E", rotulo: rot }); out.push({ cod: `${n}EI`, eixo: n, col: -1, lado: "E", rotulo: rot }) }
    else if (e.esq === 1) out.push({ cod: `${n}E`, eixo: n, col: -1, lado: "E", rotulo: rot })
    if (e.dir === 2) { out.push({ cod: `${n}DI`, eixo: n, col: 1, lado: "D", rotulo: rot }); out.push({ cod: `${n}DE`, eixo: n, col: 2, lado: "D", rotulo: rot }) }
    else if (e.dir === 1) out.push({ cod: `${n}D`, eixo: n, col: 1, lado: "D", rotulo: rot })
  })
  for (let s = 1; s <= (cfg.estepes || 0); s++) out.push({ cod: cfg.estepes === 1 ? "ES" : `ES${s}`, eixo: 0, col: s, lado: "S", rotulo: "Estepe", estepe: true })
  return out
}

// 0 = sem acesso, 1 = ver, 2 = lancar, 3 = gerir. O administrador da empresa tem tudo; os demais, so o que receberam.
export function nivelPneus(u: any): 0 | 1 | 2 | 3 {
  if (!u || u.perfil === "motorista") return 0
  if (u.perfil === "admin" || u.perfil === "superadmin") return 3
  const p: string[] = Array.isArray(u.permissoes) ? u.permissoes : []
  return p.includes("pneus_gerir") ? 3 : p.includes("pneus_lancar") ? 2 : p.includes("pneus_ver") ? 1 : 0
}

export const SITUACAO: Record<string, { rotulo: string; classe: string }> = {
  bom: { rotulo: "Bom", classe: "ok" },
  atencao: { rotulo: "Atenção", classe: "aviso" },
  trocar: { rotulo: "Trocar ou recapar", classe: "perigo" },
  sem_medicao: { rotulo: "Sem medição", classe: "" },
}
export const STATUS_PNEU: Record<string, string> = { estoque: "Em estoque", em_uso: "Em uso", recapagem: "Na recapagem", sucata: "Baixado" }

export const fmtNum = (v: any, c = 1) => (v == null || v === "" || !Number.isFinite(Number(v)) ? "—" : Number(v).toLocaleString("pt-BR", { minimumFractionDigits: c, maximumFractionDigits: c }))
export const fmtMoeda = (v: any) => (v == null || v === "" ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }))
export const fmtData = (d: any) => (typeof d === "string" && /^\d{4}-\d{2}-\d{2}/.test(d) ? d.slice(8, 10) + "/" + d.slice(5, 7) + "/" + d.slice(0, 4) : "—")
export const unidadeTxt = (u: any) => (u === "h" ? "h" : "km")
export const vidaTxt = (v: number) => (v === 1 ? "Novo" : `${v - 1}ª recapagem`)
